import { supplierIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const forecastingNumericFieldType = createEnum([
  "moq",
  "leadTime",
  "buffer",
  "coverageDays",
  "reorderThreshold",
]);
export type ForecastingNumericFieldType = z.infer<
  typeof forecastingNumericFieldType
>;

export const forecastingFieldType = createEnum([
  "moq",
  "leadTime",
  "buffer",
  "coverageDays",
  "reorderThreshold",
  "forecastingEnabled",
  "supplier",
]);
export type ForecastingFieldType = z.infer<typeof forecastingFieldType>;

export const bulkUpdateForecastingFields = {
  name: "bulkUpdateForecastingFields" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    field: forecastingFieldType,
    numericValue: z.number().int().min(0).optional(),
    booleanValue: z.boolean().optional(),
    supplierIds: z.array(supplierIdFormat.schema).optional(),
  }),
  output: z.object({ updatedCount: z.number().int() }),
};
